/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Step Four View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';
import * as authActions from '@nephro/redux/stores/auth/actions';

// Dependencies
import { connect } from 'react-redux';

// View
import { bindActionCreators } from 'redux';
import View from './stepFourView';

export const mapStateToPropsStepFour = mapStateToProps;
export const mapDispatchToPropsStepFour = (dispatch) => ({
  authActions: bindActionCreators(authActions, dispatch),
  ...mapDispatchToProps
});

export default connect(
  mapStateToPropsStepFour,
  mapDispatchToPropsStepFour
)(View);
